import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogConfig,
} from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FileUploadComponent } from '../../home/text-upload-select/file-upload/file-upload.component';
import { SeeMorePopupComponent } from '../see-more-popup/see-more-popup.component';
import { DocumentViewerDialogComponent } from '../document-viewer-dialog/document-viewer-dialog.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SubstantiationPopupService } from './substantiation-popup-service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingService } from '../../../../services/loading.service';
import { ClickOutsideDirective } from '../../../../directives/app-click-outside.directive';
import { HighlightPipe } from '../highlight.pipe';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PopupType } from '../../../../widgets/app-popup/app-popup.component';
import { IraAlertPopupComponent } from '../../../../widgets/ira-alert-popup/ira-alert-popup.component';
import { AssetSelectionDialogComponent } from '../asset-selection-dialog/asset-selection-dialog.component';
import { SaveAssetPopupComponent } from '../../../../widgets/save-asset-popup/save-asset-popup.component';
import { Converters } from '../../../../static/converters';
import { DropdownModule } from 'primeng/dropdown';
import { Overlay } from '@angular/cdk/overlay';

export interface Element {
  description: string;
  substantiationId: any;
  releted_product: string;
  releted_projects: string;
  relatedClaims: string[];
  document_link: string;
}

export interface Substantiation {
  substantiationId: string;
  description: string;
  relatedProducts?: string[];
  relatedProjects?: string[];
  relatedClaims?: string[];
  documentLink?: string;
  geography?: string;
  substantiationDetails?: string;
  // Add other properties as per your image
}

// create tab
export interface CreateSubstantiation {
  substantiationId: string;
  description: string;
  geography: string;
  substantiationDetails: string;
  documentLink: string;
}

@Component({
  selector: 'app-substantiation-popup',
  standalone: true,
  imports: [
    MatTableModule,
    MatIcon,
    MatButton,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    FormsModule,
    MatCheckboxModule,
    MatRadioModule,
    FileUploadComponent,
    NgClass,
    MatTabsModule,
    CommonModule,
    NgIf,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatSelectModule,
    MatTooltipModule,
    ClickOutsideDirective,
    HighlightPipe,
    MatPaginatorModule,
    DropdownModule,
  ],
  templateUrl: './substantiation-popup.component.html',
  styleUrl: './substantiation-popup.component.scss',
  //encapsulation: ViewEncapsulation.ShadowDom,
})
export class SubstantiationPopupComponent implements OnInit, AfterViewInit {
  isSearchVisible = false;
  documentDetails: any;
  filterValue: any;
  substantiationIdSearch: boolean = false;
  recentsubstantiationIdSearch: boolean = false;
  textFilter = new FormControl('');
  descriptionSearch: boolean = false;
  recentdescriptionSearch: boolean = false;
  showRelatedProductsFilter: boolean = false;
  recentshowRelatedProductsFilter: boolean = false;
  // relatedProductsFilter = new FormControl([]);
  showRelatedProjectsFilter: boolean = false;
  recentshowRelatedProjectsFilter: boolean = false;
  //relatedProjectsFilter = new FormControl([]);
  showRelatedClaims: boolean = false;
  recentSubType: boolean = false;
  selectedGeography: any;
  createDataForm: FormGroup;
  //geographyData: any ;
  productsData: any;
  selectedProduct: any;
  selectedProjectName: any;
  evidenceSubtypes: any;
  //descriptionText: string = '';
  supportSummaryText: string = '';
  selectedSearchType: string = 'Product';
  selectedFileName = '';
  searchText: string = '';
  descriptionLength = 0;
  descriptionControl = new FormControl('');
  desc = '';
  subDetails = '';
  createdByMeChecked = false; // Initially checkbox checked
  selectedFile: File | null = null;
  //selectedCreatedSubstantiations: Substantiation[] = [];
  checkedCreatedMap: { [substantiationId: string]: boolean } = {};
  selectedTabIndex = 0;
  selectedIndex = 0;
  substantiationEvidenceSubtype = '';
  geography = '';
  description = '';
  supportSummary = '';
  documentName = '';
  file: File | null = null;
  maxLength = 1000;
  selectedValue: any;
  dataSource = new MatTableDataSource([]); // for search  tab
  recent_dataSource = new MatTableDataSource([]); // for recently used tab
  selectedElement: Element | null = null;
  selectedElements: any[] = [];
  editableFileName: string = '';
  availableSubstantiations: Substantiation[] = [];
  availableSubstantiationsDataSource = [];

  substantiationIdFilter = new FormControl('');
  descriptionFilter = new FormControl('');
  relatedProductsFilterCtrl = new FormControl('');
  relatedProjectsFilterCtrl = new FormControl('');
  relatedClaimsFilterCtrl = new FormControl('');

  recentsubstantiationIdFilter = new FormControl('');
  recentdescriptionFilter = new FormControl('');
  recentrelatedProductsFilterCtrl = new FormControl('');
  recentrelatedProjectsFilterCtrl = new FormControl('');
  recentsubTypeFilterCtrl = new FormControl('');

  // Data for the bottom table (selected items)
  selectedSubstantiations: Substantiation[] = [];
  selectedSubstantiationsDataSource = []; // Use MatTableDataSource
  selectedAssetId: number | null = null;

  // dropdown value in create tab
  subtype_options: Array<{ label: string; value: string }> = [];
  country_options: Array<{ label: string; value: string }> = [];

  // crete API
  selectedFileBase64: string | null = null; // Set on file upload for API
  geographyFilter: string = '';
  filteredCountryOptions: any[] = [];
  createdbyMetooltipText: any;
  name: any;
  email: any;

  //aded for pagination
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // SelectionModel for the top table
  selection = new SelectionModel<Substantiation>(true, []);
  // options_relatedProducts: string[] = [
  //   'Concept Claims',
  //   'Pack BOP',
  //   'Omnichannel',
  //   'E-Commerce',
  //   'Pack FOP',
  //   'E-Commerce',
  //   'Omnichannel',
  // ];
  // options_relatedProjects: string[] = [
  //   'Concept Claims',
  //   'Pack BOP',
  //   'Omnichannel',
  //   'E-Commerce',
  //   'Pack FOP',
  //   'E-Commerce',
  //   'Omnichannel',
  // ];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SubstantiationPopupComponent>,
    //public dialogRef1: MatDialogRef<SeeMorePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private substantiationPopupService: SubstantiationPopupService,
    public loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private overlay: Overlay
  ) {
    this.descriptionControl = new FormControl('', [
      Validators.required,
      Validators.maxLength(1000),
    ]);
    // this.createDataForm = this.fb.group({
    //   evidenceSubtype: ['', Validators.required],
    //   geography: [''],
    //   descriptionText: ['', [Validators.maxLength(1000)]],
    //   supportSummaryText: [''],
    //   documentName: [{ value: '', disabled: true }, Validators.required],
    // });
    this.selectedGeography = localStorage.getItem('geographyName');
    this.createDataForm = this.fb.group({
      evidenceSubtype: ['', Validators.required],
      geography: [''],
      description: ['', [Validators.required, Validators.maxLength(1500)]],
      supportSummaryText: [''],
      documentName: [{ value: '', disabled: true }, Validators.required],
    });
  }

  ngOnInit() {
    (this.name = sessionStorage.getItem('loggedInUser')),
      (this.email = sessionStorage.getItem('username')),
      (this.createdbyMetooltipText = `Name: ${this.name}\n \n  
      Email: ${this.email}`);
    this.filteredCountryOptions = this.country_options;

    this.fetchRecentlyUsedSubstantiation();

    this.createDataForm.get('documentName')?.valueChanges.subscribe((value) => {
      console.log('Document name changed:', value);
    });

    this.recentsubstantiationIdFilter.valueChanges.subscribe(() =>
      this.applyRecentFilter()
    );
    this.recentdescriptionFilter.valueChanges.subscribe(() =>
      this.applyRecentFilter()
    );
    this.recentrelatedProductsFilterCtrl.valueChanges.subscribe(() =>
      this.applyRecentFilter()
    );
    this.recentrelatedProjectsFilterCtrl.valueChanges.subscribe(() =>
      this.applyRecentFilter()
    );
    this.recentsubTypeFilterCtrl.valueChanges.subscribe(() =>
      this.applyRecentFilter()
    );
  }

  // recently used search functionality
  applyRecentFilter() {
    const idFilter =
      this.recentsubstantiationIdFilter.value?.toLowerCase() || '';
    const descFilter = this.recentdescriptionFilter.value?.toLowerCase() || '';
    const productsFilter =
      this.recentrelatedProductsFilterCtrl.value?.toLowerCase() || '';
    const projectsFilter =
      this.recentrelatedProjectsFilterCtrl.value?.toLowerCase() || '';
    const subtypeFilter =
      this.recentsubTypeFilterCtrl.value?.toLowerCase() || '';

    this.recent_dataSource.filterPredicate = (data: any, filter: string) => {
      return (
        data.substantiationId?.toLowerCase().includes(idFilter) &&
        data.description?.toLowerCase().includes(descFilter) &&
        data.relatedProducts
          ?.join(',')
          .toLowerCase()
          .includes(productsFilter) &&
        data.relatedProjects
          ?.join(',')
          .toLowerCase()
          .includes(projectsFilter) &&
        data.subType?.toLowerCase().includes(subtypeFilter)
      );
    };

    // Trigger filter with dummy value (actual filtering is done inside predicate)
    this.recent_dataSource.filter = String(Date.now());
    //this.recent_dataSource.filter = Math.random().toString();
  }

  // create button enable disable check
  get isCreateDisabled(): boolean {
    return (
      this.createDataForm.invalid ||
      (!this.selectedFileBase64 && !this.selectedAssetId)
    );
  }

  ngAfterViewInit() {
    // This is the right place to set paginator
    this.dataSource.paginator = this.paginator;
    this.recent_dataSource.paginator = this.paginator;
  }

  filterGeographies() {
    const filterValue = this.geographyFilter.toLowerCase();
    this.filteredCountryOptions = this.country_options.filter((option) =>
      option.label.toLowerCase().includes(filterValue)
    );
  }

  displayedColumns: string[] = [
    'checkbox',
    'substantiationId',
    'description',
    'relatedProducts',
    'relatedProjects',
    'relatedClaims',
    'documentLink',
    'documentUpload',
  ];

  displayedColumnsWithRemove: string[] = [
    'checkbox',
    'substantiationId',
    'description',
    'relatedProducts',
    'relatedProjects',
    'relatedClaims',
    'documentLink',
    'documentUpload',
    'remove',
  ];

  recentlyUseddisplayedColumns: string[] = [
    'recent_checkbox',
    'recent_substantiationId',
    'recent_description',
    'recent_relatedProducts',
    'recent_relatedProjects',
    'recent_subType',
    'recent_documentLink',
  ];

  expandedRelatedProducts: { [id: string]: boolean } = {};
  expandedRelatedProjects: { [id: string]: boolean } = {};
  subType = '';

  // handleFile(event) {
  //   this.dialogRef.close(event);
  // }
  oncancelClick() {
    this.dialogRef.close(false);
  }

  getRelatedProducts(element: any): string[] {
    return element.relatedProducts || [];
  }
  // getRelatedProjects(element: any): string[] {
  //   // If your relatedProjects is a string, you may want to split or return as array
  //   return element.relatedProjects ? [element.relatedProjects] : [];
  // }
  getRelatedProjects(element: any): string[] {
    return Array.isArray(element.relatedProjects)
      ? element.relatedProjects.filter((v) => !!v && v.trim() !== '')
      : [];
  }
  // Utility to format names: insert space before uppercase letter
  formatName(name: string): string {
    // Moisturelotion => Moisture lotion, HydrationLotion => Hydration Lotion, etc.
    return name ? name.replace(/([a-z])([A-Z])/g, '$1 $2') : '';
  }

  getLastTwoLines(arr: string[]): string[][] {
    // If no items, return empty array
    if (!arr || arr.length === 0) return [];

    if (arr.length <= 2) {
      // Only one line, with last two (or one)
      return [arr.slice(-2)];
    }
    // More than 2: get last 4 and split into 2 lines of 2 each
    const lastFour = arr.slice(-4);
    const lines = [];
    if (lastFour.length > 2) {
      lines.push(lastFour.slice(0, 2)); // 3rd-4th from end
    }
    lines.push(lastFour.slice(-2)); // last two
    return lines;
  }

  getLastLinesWithThreeWords(arr: string[]): string[] {
    if (!arr || arr.length === 0) return [];
    // Take the last two items (or one if that's all there is)
    const lastItems = arr.slice(-2);
    // For each item, take the last three words and join
    return lastItems.map((item) => {
      if (!item) return '';
      const words = item.split(' ');
      const lastThree = words.slice(-2).join(' '); // change as per last how many woreds we want
      return '...' + lastThree;
    });
  }

  // for releted Product
  getLastLinesWithTwentyChars(arr: string[]): {
    lines: string[];
    showSeeMore: boolean;
  } {
    if (!arr || arr.length === 0) return { lines: [], showSeeMore: false };

    // Take the last two items (or fewer if not enough)
    const lastItems = arr.slice(-2);
    const processed: string[] = [];
    let overLimit = false;

    for (const item of lastItems) {
      if (!item) continue;
      if (item.length <= 22) {
        // Show full if <= 22 chars (no ...)
        processed.push(item);
      } else {
        overLimit = true;
        processed.push('...' + item.slice(-22));
      }
    }

    // Show "See More" only if any last item is over 20 chars or if there are more than 2 items
    const showSeeMore = overLimit || arr.length > 2;
    return { lines: processed, showSeeMore };
  }

  // reletedd Project
  getRelatedProjectsSummary(arr: string[]): {
    summary: string;
    showSeeMore: boolean;
  } {
    if (!arr || arr.length === 0) return { summary: '', showSeeMore: false };
    const fullText = arr.join(', ');
    if (fullText.length <= 22) {
      return { summary: fullText, showSeeMore: false };
    } else {
      return { summary: fullText.slice(0, 22) + '...', showSeeMore: true };
    }
  }

  // Releted Claims/LA
  getRelatedClaimsSummary(claims: string[]): {
    lines: string[];
    showSeeMore: boolean;
  } {
    return this.getTwoLineSummary(claims.join(', '));
  }
  getTwoLineSummary(text: string): { lines: string[]; showSeeMore: boolean } {
    if (!text) return { lines: [], showSeeMore: false };
    const firstLine = text.slice(0, 40);
    let secondLine = '';
    let showSeeMore = false;

    if (text.length > 40) {
      secondLine = text.slice(40, 80);
      if (text.length > 80) {
        secondLine += '...';
        showSeeMore = true;
      }
    }

    const lines = secondLine ? [firstLine, secondLine] : [firstLine];
    return { lines, showSeeMore };
  }

  // openSeeMorePopup(
  //   element: Element,
  //   type: 'products' | 'projects' | 'claims',
  //   event: Event
  // ) {
  //   event.preventDefault();

  //   // Prepare the data to show in the popup
  //   let detailsToShow: string[] = [];
  //   let title = '';
  //   if (type === 'products') {
  //     detailsToShow = this.getRelatedProducts(element);
  //     title = 'Related Products';
  //   } else if (type === 'projects') {
  //     detailsToShow = this.getRelatedProjects(element);
  //     title = 'Related Projects';
  //   } else if (type === 'claims') {
  //     detailsToShow = element.relatedClaims || [];
  //     title = 'Related Claims/LA';
  //   }

  //   this.dialog.open(SeeMorePopupComponent, {
  //     width: '44%',
  //     height: '50%',
  //     disableClose: true,
  //     data: {
  //       title: title,
  //       items: detailsToShow,
  //       searchText: this.searchText,
  //     },
  //   });
  // }

  openSeeMorePopup(
    element: any,
    type: 'products' | 'projects' | 'claims',
    event: Event
  ) {
    event.preventDefault();

    // Prepare array values
    let productNames: string[] = [];
    let projectNames: string[] = [];
    let claimNames: string[] = [];

    if (type === 'products') {
      productNames = this.getRelatedProducts(element) || [];
    } else if (type === 'projects') {
      projectNames = this.getRelatedProjects(element) || [];
      // productNames = (this.getRelatedProducts(element) || []).map(
      //   (name: string) => name.replace(/'/g, "''")
      // );
      console.log(productNames, 'productNames');
    } else if (type === 'claims') {
      console.log(element.relatedClaims, 'element.relatedClaims');
      //claimNames = (element.relatedClaims || []).map((c: any) => c.claim_name);
      claimNames = element.relatedClaims.map((s) => s.split(' - ')[0]);
      console.log(claimNames, 'claimNames');
    }

    const see_more_value =
      type === 'products'
        ? 'related_products'
        : type === 'projects'
        ? 'related_projects'
        : 'related_claim_la';

    if (see_more_value === 'related_products') {
      productNames = (productNames || []).map((name: string) =>
        name.replace(/'/g, "''")
      );
    }
    console.log(productNames, ' productNames after replace');

    // Build payload with stringified arrays
    const payload: any = {
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
      see_more_value,
      //   type === 'products'
      //     ? 'related_products'
      //     : type === 'projects'
      //     ? 'related_projects'
      //     : 'related_claim_la',
      product_names: JSON.stringify(productNames),
      project_names: JSON.stringify(projectNames),
      related_claim_la_statements: JSON.stringify(claimNames),
      geography_id: localStorage.getItem('geography') || '',
    };

    // Show loader
    this.loadingService.setLoading(true);

    this.substantiationPopupService
      .substantiationSearchSeeMore(payload)
      .subscribe({
        next: (response: any[]) => {
          // Prepare data for the popup as before
          let title = '';
          let items: any[] = [];
          if (type === 'products' || type === 'projects') {
            title =
              type === 'products' ? 'Related Products' : 'Related Projects';
            // items = response.map((item) => ({
            //   display: item.title, // or item.name if you prefer
            //   url: item.link,
            // }));
            items = response.map((item) => ({
              name: item.name,
              title: item.title,
              url: item.link,
              display: `${item.name} - ${item.title}`,
            }));
          }
          //  else if (type === 'claims') {
          //   title = 'Related Claims/LA';
          //   items = response.map((item) => ({
          //     display: item.statement,
          //     url: item.link,
          //   }));
          // }
          else if (type === 'claims') {
            title = 'Related Claims/LA';
            items = response.map((item) => ({
              display: `${item.name} - ${item.statement}`, // for highlight pipe
              url: item.link,
              name: item.name,
              statement: item.statement,
            }));
          }

          this.dialog.open(SeeMorePopupComponent, {
            width: '44%',
            height: '50%',
            disableClose: true,
            data: {
              title,
              items,
              searchText: this.searchText,
              seeMoreType: type,
            },
          });
          this.loadingService.setLoading(false); // Hide loader after success
        },
        error: (error) => {
          // Handle error (show a message or toast as needed)
          this.loadingService.setLoading(false); // Hide loader on error
          // Optionally, show an error popup or message
          this.dialog.open(SeeMorePopupComponent, {
            width: '44%',
            height: '30%',
            disableClose: true,
            data: {
              title: 'Error',
              items: [
                `Error loading details: ${error?.message || 'Unknown error.'}`,
              ],
              searchText: this.searchText,
            },
          });
        },
      });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.availableSubstantiationsDataSource.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.availableSubstantiationsDataSource);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Substantiation): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.substantiationId + 1
    }`;
  }

  // confirmSelection() {
  //   console.log(this.selectedSubstantiations, 'this.selectedSubstantiations');
  //   this.dialogRef.close(this.selectedSubstantiations); // selectedElements: substantiations user selected
  // }

  confirmSelection() {
    // Check if Create button is enabled
    if (!this.isCreateDisabled) {
      // Show popup and return early
      this.showPopup(
        'Kindly click on "Create" to save the created substantiation before clicking on "Confirm"'
      );
      return;
    }
    const substantiationId = this.selectedSubstantiations.map(
      (item) => item.substantiationId
    );
    console.log('Payload to send:', substantiationId);

    const payload = {
      environment: localStorage.getItem('environment'),

      //user_id: 'suhana.s@unilever.com',
      user_id: localStorage.getItem('userId'),
      substantiation_id: substantiationId,
    };

    this.loadingService.setLoading(true); // Start loader

    this.substantiationPopupService
      .saveRecentlyUsedSubstantiation(payload)
      .subscribe({
        next: (response) => {
          console.log('API response:', response);
          this.loadingService.setLoading(false); // Stop loader
          this.dialogRef.close(this.selectedSubstantiations);
        },
        error: (err) => {
          console.error('API error:', err);
          this.loadingService.setLoading(false); // Stop loader on error
        },
      });
  }

  removeSelectedSubstantiation(itemToRemove: Substantiation) {
    // Remove from the bottom table
    this.selectedSubstantiations = this.selectedSubstantiations.filter(
      (item) => item !== itemToRemove
    );
    this.selectedSubstantiationsDataSource = [...this.selectedSubstantiations];

    // Optionally, add it back to the top table if that's the desired behavior
    this.availableSubstantiations = [
      ...this.availableSubstantiations,
      itemToRemove,
    ];
    this.availableSubstantiationsDataSource = [
      ...this.availableSubstantiations,
    ];

    this.dialogRef.close(this.selectedElements);
  }

  // Add search/filter functionality as needed
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
  }

  // SEARCH TAB selection logic
  onToggleRow(element: Substantiation, event: any) {
    if (event.checked) {
      if (
        !this.selectedSubstantiations.some(
          (e) => e.substantiationId === element.substantiationId
        )
      ) {
        this.selectedSubstantiations = [
          ...this.selectedSubstantiations,
          element,
        ];
      }
    } else {
      this.selectedSubstantiations = this.selectedSubstantiations.filter(
        (e) => e.substantiationId !== element.substantiationId
      );
    }
    //Update SelectionModel for UI
    this.selection.clear();
    this.selectedSubstantiations.forEach((e) => this.selection.select(e));
  }
  isSelected(element: Substantiation): boolean {
    return this.selectedSubstantiations.some(
      (e) => e.substantiationId === element.substantiationId
    );
  }

  isCreatedSubstantiation(sub: Substantiation): boolean {
    // If created in Create tab, you can flag with a property or check by other means
    return sub.hasOwnProperty('isCreated');
  }

  onRowClick(row: any, event: MouseEvent) {}

  removeFromSelected(element: Substantiation) {
    this.selectedSubstantiations = this.selectedSubstantiations.filter(
      (e) => e.substantiationId !== element.substantiationId
    );
    this.selection.deselect(element); // If it's from the search, reflect change in UI
  }

  toggleSearch() {}
  // To clear the statement text data in search bar
  clearSearch() {
    this.substantiationIdFilter.setValue('');
  }

  // To clear the recently used statement text data in search bar
  recentclearSearch() {
    this.recentsubstantiationIdFilter.setValue('');
  }
  // To clear the description data in search bar
  descclearSearch() {
    this.descriptionFilter.setValue('');
  }

  // To clear the recent used description data in search bar
  recentdescclearSearch() {
    this.recentdescriptionFilter.setValue('');
  }

  // clear Product Search
  clearProductSearch() {
    this.relatedProductsFilterCtrl.setValue('');
  }

  // clear recent used Product Search
  recentclearProductSearch() {
    this.recentrelatedProductsFilterCtrl.setValue('');
  }

  // Project Search
  clearProjectSearch() {
    this.relatedProjectsFilterCtrl.setValue('');
  }
  // recent Project Search
  recentclearProjectSearch() {
    this.recentrelatedProjectsFilterCtrl.setValue('');
  }

  // related claim seach
  clearRelatedClaimsSearch() {
    this.relatedClaimsFilterCtrl.setValue('');
  }

  // related used subtype seach
  clearRecentSubTypeSearch() {
    this.recentsubTypeFilterCtrl.setValue('');
  }

  toggleSubstantiationIdSearch() {
    this.substantiationIdSearch = !this.substantiationIdSearch;
  }
  // recent used substantiation id search
  toggleRecentSubstantiationIdSearch() {
    this.recentsubstantiationIdSearch = !this.recentsubstantiationIdSearch;
  }
  toggleDescriptionSearch() {
    this.descriptionSearch = !this.descriptionSearch;
  }
  // recent used description search
  toggleRecentDescriptionSearch() {
    this.recentdescriptionSearch = !this.recentdescriptionSearch;
  }
  toggleRelatedProductsFilter() {
    this.showRelatedProductsFilter = !this.showRelatedProductsFilter;
  }
  // recent used product  search
  toggleRecentRelatedProductsFilter() {
    this.recentshowRelatedProductsFilter =
      !this.recentshowRelatedProductsFilter;
  }
  toggleRelatedProjectsFilter() {
    this.showRelatedProjectsFilter = !this.showRelatedProjectsFilter;
  }
  // recent used project  search
  toggleRecentRelatedProjectsFilter() {
    this.recentshowRelatedProjectsFilter =
      !this.recentshowRelatedProjectsFilter;
  }
  toggleRelatedClaimsFilter() {
    this.showRelatedClaims = !this.showRelatedClaims;
  }
  // recent used subtype
  toggleRecentSubType() {
    this.recentSubType = !this.recentSubType;
  }

  // reason column
  splitReasonByWords(
    relatedClaims: string,
    wordsPerLine: number = 6
  ): string[] {
    if (!relatedClaims) return [];
    const words = relatedClaims.split(' ');
    const lines = [];
    for (let i = 0; i < words.length; i += wordsPerLine) {
      lines.push(words.slice(i, i + wordsPerLine).join(' '));
    }
    return lines;
  }

  getGeographyValue(event?) {}
  getProductValue(event?) {}

  onDocumentUpload() {}
  removeGeographyValue() {}

  uploadProgress = 0;
  uploadInProgress = false;
  isDocumentUploaded = false;
  documentExtension = '';
  // selectedFile: File | null = null;
  uploadInterval: any;
  fileUrl: string | null = null; // For preview/download

  splitNameAndExtension(filename: string): { name: string; extension: string } {
    const lastDot = filename.lastIndexOf('.');
    if (lastDot === -1) return { name: filename, extension: '' };
    return {
      name: filename.substring(0, lastDot),
      extension: filename.substring(lastDot),
    };
  }

  // with video restrict
  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileType = file.type;
      const fileName = file.name;

      // Reset evidence subtype dropdown
      this.createDataForm.get('evidenceSubtype')?.reset();
      this.createDataForm.get('evidenceSubtype')?.enable();

      // Restrict video uploads
      if (fileType.startsWith('video/')) {
        this.showPopup(
          'Video files cannot be uploaded here. To create Substantiation Evidence with video files, please go to the Substantiation Library and add.'
        );
        return;
      }
      const fileConvert = await Converters.toBase64(file as any);
      console.log(fileConvert, 'fileConvert');
      // Read file as base64
      //const reader = new FileReader();
      // reader.onload = () => {
      // this.selectedFileBase64 = (reader.result as string).split(',')[1];
      // const fileConvert = Converters.toBase64(reader.result as any);
      this.selectedFileBase64 = fileConvert.split(',')[1];
      console.log(this.selectedFileBase64, 'fileConvert');
      this.selectedFile = file;
      this.selectedAssetId = null; // Reset previous asset selection

      // const { name, extension } = this.splitNameAndExtension(file.name);
      // this.createDataForm.get('documentName')?.setValue(name);
      // this.documentExtension = extension;
      const { name, extension } = this.splitNameAndExtension(file.name);
      this.createDataForm.get('documentName')?.setValue(name); // Editable input
      this.documentExtension = extension; // Shown below

      this.createDataForm.get('documentName')?.enable();

      if (this.fileUrl) {
        URL.revokeObjectURL(this.fileUrl);
      }
      this.fileUrl = URL.createObjectURL(file);

      // Check for duplicate asset
      const payload = {
        session_id: sessionStorage.getItem('sessionId'),
        file_name: fileName,
        file_data: this.selectedFileBase64,
        environment: localStorage.getItem('environment'),
        sub_type: '',
        asset_lifecycle: '',
        project_id: '',
        business_group: '',
        category: '',
      };
      this.loadingService.setLoading(true);
      this.substantiationPopupService.checkAssetExist(payload).subscribe({
        next: (response: any[]) => {
          console.log(response, 'checkAssetExist');
          this.loadingService.setLoading(false);
          // if (response && response.length > 0) {
          //   this.openAssetSelectionDialog(response, file);
          //   return;
          // }
          if (response && response.length > 0) {
            const substantiationEvidenceAssets = response.filter(
              (asset) => asset.type === 'Substantiation Evidence'
            );

            if (substantiationEvidenceAssets.length > 0) {
              this.openAssetSelectionDialog(substantiationEvidenceAssets, file);
              return;
            }
          }
        },
        error: () => {
          this.loadingService.setLoading(false);
          this.showPopup(
            'Something went wrong while checking the file. Please try again.'
          );
        },
      });

      // reader.readAsDataURL(file);
    }
  }

  openAssetSelectionDialog(assets: any[], uploadedFile: File) {
    const filePreviewUrl = URL.createObjectURL(uploadedFile);

    const dialogRef = this.dialog.open(AssetSelectionDialogComponent, {
      width: '450px',
      height: '300px',
      disableClose: true,
      data: {
        assets,
        uploadedFile,
        filePreviewUrl,
      },
    });

    dialogRef.afterClosed().subscribe((selectedAsset) => {
      if (selectedAsset) {
        // User selected an asset: use its id for API, clear file/base64
        this.createDataForm
          .get('documentName')
          ?.setValue(selectedAsset.asset_name.replace(/\.[^/.]+$/, ''));
        //this.documentExtension = selectedAsset.asset_name.split('.').pop();

        this.selectedAssetId = selectedAsset.id;
        this.selectedFile = null;
        this.selectedFileBase64 = null;
        if (this.fileUrl) {
          URL.revokeObjectURL(this.fileUrl);
          this.fileUrl = null;
        }

        // Set evidence subtype from selected asset and disable the dropdown
        if (selectedAsset.subtype__v) {
          this.createDataForm
            .get('evidenceSubtype')
            ?.setValue(selectedAsset.subtype__v);
          this.createDataForm.get('evidenceSubtype')?.disable();
        }
      } else {
        // User cancelled: keep uploaded file and base64
        this.selectedFile = uploadedFile;
        const { name, extension } = this.splitNameAndExtension(
          uploadedFile.name
        );
        this.createDataForm.get('documentName')?.setValue(name);
        this.documentExtension = extension;
        this.createDataForm.get('documentName')?.enable();
        if (this.fileUrl) {
          URL.revokeObjectURL(this.fileUrl);
        }
        this.fileUrl = URL.createObjectURL(uploadedFile);
        this.selectedAssetId = null;

        // Re-enable the dropdown if user cancels selection
        this.createDataForm.get('evidenceSubtype')?.enable();
      }
    });
  }

  onCreateSubstantiation() {
    if (
      this.createDataForm.invalid ||
      (!this.selectedAssetId && !this.selectedFileBase64)
    ) {
      this.createDataForm.markAllAsTouched();
      return;
    }

    this.loadingService.setLoading(true);

    const form = this.createDataForm.value;

    const payload: any = {
      environment: localStorage.getItem('environment'),
      session_id: sessionStorage.getItem('sessionId'),
      //session_id:
      // '26AEF3AA36074CEEA7B6D20EE950D73FB20FB674961E1C5D40CD44AF265B019008FBA3E3A581E9A3F11A8E9C23EA0289E90E8501EDE14B34D03BF22D1EE06C7E',
      substantiation_subtype: form.evidenceSubtype,
      file_base64: this.selectedAssetId ? '' : this.selectedFileBase64 || '',
      file_name: this.selectedAssetId
        ? ''
        : this.createDataForm.get('documentName')?.value +
          (this.documentExtension || ''),
      substantiation_description: form.description,
      substantiation_details: form.supportSummaryText,
      substantiation_geography: form.geography,
      document_id: this.selectedAssetId || '',
      //file_type: this.selectedAssetId ? '' : this.selectedFile?.type || '',
    };
    this.substantiationPopupService.createSubstantiation(payload).subscribe({
      next: (res) => {
        this.loadingService.setLoading(false);

        // Check if there's an error in the response
        const uploadResult = res?.upload_result;
        if (uploadResult?.error) {
          // Show the error in a popup
          this.showPopup(uploadResult.error);
          return; // Exit early if there's an error
        }

        // Parse response as per your sample
        const dataArr = res?.upload_result?.create_response?.data;
        console.log(dataArr, 'dataArr');
        if (Array.isArray(dataArr) && dataArr.length > 0) {
          const data = dataArr[0];
          const substantiation = {
            substantiationId: data.name__v || '',
            substantiation_link: data.id,
            description: data.description__v || '',
            substantiationDetails: data.substantiation_details__c || '',
            documentName: data['related_reference__vr.name__v'],
            documentLink: data.related_reference__v,
            subType: data['related_reference__vr.subtype__v'],
            geography: data['country__cr.name__v'],

            // add more fields if needed
          };
          console.log(substantiation, 'substantiation');
          // Only add if not already present
          if (
            !this.selectedSubstantiations.some(
              (s) => s.substantiationId === substantiation.substantiationId
            )
          ) {
            this.selectedSubstantiations = [
              ...this.selectedSubstantiations,
              substantiation,
            ];
          }
        }

        // Reset form and file state
        this.createDataForm.reset();
        this.selectedFile = null;
        this.selectedFileBase64 = null;
        this.selectedAssetId = null;
        this.documentExtension = '';
        this.subDetails = '';
        this.desc = '';
        if (this.fileUrl) {
          URL.revokeObjectURL(this.fileUrl);
          this.fileUrl = null;
        }
      },
      error: (err) => {
        this.loadingService.setLoading(false);
        //this.showPopup('Failed to create substantiation. Please try again.');
      },
    });
  }
  showPopup(message: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.height = '190px';
    dialogConfig.width = '390px';
    dialogConfig.data = {
      message,
      buttons: [{ id: 'OK', text: 'OK' }],
      submitButtonId: 'OK',
      messageType: 'fileUpload',
      type: PopupType.ERROR,
    } as any;

    this.dialog
      .open(IraAlertPopupComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {});
  }

  // Prevent user from entering a dot in the name
  onNameInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.value.includes('.')) {
      this.createDataForm
        .get('documentName')
        ?.setValue(input.value.replace(/\./g, ''));
    }
  }

  // simulateUpload() {
  //   this.uploadInProgress = true;
  //   this.uploadProgress = 0;
  //   this.isDocumentUploaded = false;
  //   if (this.uploadInterval) clearInterval(this.uploadInterval);

  //   this.uploadInterval = setInterval(() => {
  //     if (this.uploadProgress >= 100) {
  //       clearInterval(this.uploadInterval);
  //       this.uploadInProgress = false;
  //       this.isDocumentUploaded = true;
  //     } else {
  //       this.uploadProgress += 10; // increase speed as needed
  //     }
  //   }, 150); // adjust interval for speed
  // }

  // Clean up object URLs when component is destroyed
  ngOnDestroy() {
    if (this.fileUrl) {
      URL.revokeObjectURL(this.fileUrl);
    }
  }

  // Optionally, for download button
  downloadFile() {
    if (!this.fileUrl || !this.selectedFile) return;
    // Get the latest name from your form and append the extension
    const baseName =
      this.createDataForm.get('documentName')?.value || 'downloaded_file';
    const downloadName = baseName + this.documentExtension; // e.g. "renamedfile.pdf"
    const a = document.createElement('a');
    a.href = this.fileUrl;
    a.download = downloadName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // CREATE TAB creation logic
  // onCreateSubstantiation() {
  //   if (this.createDataForm.invalid) {
  //     this.createDataForm.markAllAsTouched();
  //     return;
  //   }
  //   const form = this.createDataForm.value;
  //   const substantiationId = ''; // keep it empty for created ones
  //   const newSubstantiation: Substantiation = {
  //     substantiationId,
  //     description: this.desc || form.descriptionText || '',
  //     geography: form.geography || '',
  //     substantiationDetails: this.subDetails || form.supportSummaryText || '',
  //     documentLink: form.documentName
  //       ? form.documentName + (this.documentExtension || '')
  //       : '',
  //   };
  //   // Only add if not already present (by description+details etc. if you want to avoid duplicates)
  //   this.selectedSubstantiations = [
  //     ...this.selectedSubstantiations,
  //     newSubstantiation,
  //   ];
  //   this.createDataForm.reset();
  //   this.desc = '';
  //   this.subDetails = '';
  //   this.documentExtension = '';
  // }

  // onCreateSubstantiation() {
  //   if (this.createDataForm.invalid) {
  //     // Optionally mark all as touched to show errors
  //     this.createDataForm.markAllAsTouched();
  //     return;
  //   }

  //   this.loadingService.setLoading(true);

  //   const payload = {
  //     environment: localStorage.getItem('environment'),
  //     session_id: sessionStorage.getItem('sessionId'),
  //     substantiation_subtype: 'Survey',
  //     file_base64: '',
  //     file_name: 'testingfiless.jpg',
  //     substantiation_description: 'DEV or QA',
  //     substantiation_details: 'Details about substantiation',
  //     substantiation_geography: 'India',
  //     document_id: '',
  //   };

  //   this.substantiationPopupService.createSubstantiation(payload).subscribe({
  //     next: (res) => {
  //       console.log(res, 'crrate resp');
  //       this.loadingService.setLoading(false);
  //       this.createDataForm.reset();
  //       this.descriptionControl.reset();
  //       this.selectedFile = null;
  //       this.documentExtension = '';
  //       // Optionally show success message
  //     },
  //     error: (err) => {
  //       this.loadingService.setLoading(false);
  //       // Optionally show error message
  //     },
  //   });
  // }

  onRemoveCreated(element: Substantiation) {
    this.selectedSubstantiations = this.selectedSubstantiations.filter(
      (e) => e.substantiationId !== element.substantiationId
    );
    this.selection.deselect(element); // Optionally, if you want to update the checkbox UI in the search table
  }

  // Only send created substantiations
  onConfirmCreateTab() {
    this.dialogRef.close(this.selectedSubstantiations);
  }
  //confirm button disabled
  get isConfirmDisabled(): boolean {
    return this.selectedSubstantiations.length === 0;
  }

  // related Claims split by 6 words
  splitBySixWords(text: string): string[] {
    if (!text) return [];
    // Split by space, then group into chunks of 6
    const words = text.split(/\s+/);
    const lines: string[] = [];
    for (let i = 0; i < words.length; i += 6) {
      lines.push(words.slice(i, i + 6).join(' '));
    }
    return lines;
  }

  //search method
  lastSearchType: string = '';
  noDataMessage: string = '';
  // onSearchClick() {
  //   this.lastSearchType = this.selectedSearchType;
  //   this.noDataMessage = ''; // Reset message before each search

  //   // Prepare the payload based on the selected radio button and search text
  //   const data = {
  //     session_id: sessionStorage.getItem('sessionId'),
  //     // session_id:
  //     //   'E698791D8898F58A940F2C362CD241AA0B12024C4F5979F685123445FC64DB6CF96BC450EA11467AEA1E20FD242C3B59A641CF7E89203393B3A6F6A4313E9D00',
  //     product_name:
  //       this.selectedSearchType === 'Product' ? this.searchText : '',
  //     project_name:
  //       this.selectedSearchType === 'Project' ? this.searchText : '',
  //     claim_la_statement:
  //       this.selectedSearchType === 'Claim/LA' ? this.searchText : '',
  //     document_name:
  //       this.selectedSearchType === 'Document Name' ? this.searchText : '',
  //     document_content:
  //       this.selectedSearchType === 'Document Content' ? this.searchText : '',
  //     environment: localStorage.getItem('environment'),
  //     geography_id: localStorage.getItem('geography') || '',
  //     created_by: this.createdByMeChecked ? localStorage.getItem('userId') : '',
  //     //...(this.createdByMeChecked ? { created_by: 'test@unilever.com' } :{} ),
  //   };

  //   // Show loading spinner
  //   this.loadingService.setLoading(true);

  //   //const SEARCH_TIMEOUT = 10000; // 10 seconds
  //   const SEARCH_TIMEOUT = 7000; // 7 seconds
  //   //const SEARCH_TIMEOUT = 120000; // 2 minutes
  //   let timeoutTriggered = false;
  //   let searchSubscription: any;

  //   const timeoutId = setTimeout(() => {
  //     timeoutTriggered = true;
  //     this.loadingService.setLoading(false);

  //     const dialogConfig = new MatDialogConfig();
  //     dialogConfig.disableClose = true;
  //     dialogConfig.height = '190px';
  //     dialogConfig.width = '390px';
  //     dialogConfig.data = {
  //       message:
  //         'The search is taking longer than expected. Would you like to wait or start a new search instead?',
  //       buttons: [
  //         { id: 'CANCEL', text: 'Cancel' },
  //         { id: 'CONTINUE', text: 'Continue' },
  //       ],
  //       submitButtonId: 'CONTINUE',
  //       messageType: 'msgNotify',
  //       type: 'PROCEED',
  //     } as any;

  //     this.dialog
  //       .open(IraAlertPopupComponent, dialogConfig)
  //       .afterClosed()
  //       .subscribe((result) => {
  //         if (result === false) {
  //           if (searchSubscription) {
  //             searchSubscription.unsubscribe();
  //           }
  //         }
  //         if (result === true) {
  //           this.loadingService.setLoading(true);
  //           timeoutTriggered = false; // Allow response handler to run
  //         }
  //       });
  //   }, SEARCH_TIMEOUT);

  //   searchSubscription = this.substantiationPopupService
  //     .getSearchSubstantiation(data)
  //     .subscribe({
  //       next: (response) => {
  //         console.log(response, 'response aaa');
  //         if (timeoutTriggered) {
  //           this.loadingService.setLoading(false);
  //           return;
  //         }
  //         clearTimeout(timeoutId);
  //         if (response && Array.isArray(response) && response.length > 0) {
  //           const tableData = response.map((item) => {
  //             // Substantiation ID
  //             const substantiationId = item['substantiation'] || '';

  //             // Description
  //             const description = item['description'] || '';

  //             // Related Claims/LA (unified)
  //             let relatedClaims: string[] = [];
  //             if (
  //               Array.isArray(item.related_claims) &&
  //               item.related_claims.length
  //             ) {
  //               relatedClaims = item.related_claims.map((claim) =>
  //                 `${claim.claim_name || ''} - ${
  //                   claim.claim_statement || ''
  //                 }`.trim()
  //               );
  //             } else if (
  //               Array.isArray(item.related_la) &&
  //               item.related_la.length
  //             ) {
  //               relatedClaims = item.related_la.map((la) =>
  //                 `${la.la_name || ''} - ${la.la_statement || ''}`.trim()
  //               );
  //             }

  //             // Related Projects (array of strings)
  //             let relatedProjects: string[] = [];
  //             if (this.selectedSearchType === 'Project') {
  //               // Only map project__vr.name__v if searching by Project
  //               if (Array.isArray(item.related_projects)) {
  //                 relatedProjects = item.related_projects.map(
  //                   (proj) => proj['project__vr.name__v'] || ''
  //                 );
  //               }
  //             } else {
  //               relatedProjects = Array.isArray(item.related_projects)
  //                 ? item.related_projects
  //                 : [];
  //             }

  //             // Related Products (array of strings)
  //             const relatedProducts = Array.isArray(item.related_products)
  //               ? item.related_products
  //               : [];

  //             // Document Link
  //             const documentLink =
  //               item.doc_link === null ||
  //               item.doc_link === undefined ||
  //               item.doc_link === 'null' ||
  //               item.doc_link === 'undefined'
  //                 ? ''
  //                 : item.doc_link;
  //             const documentName = item.doc_name;

  //             return {
  //               substantiationId,
  //               description,
  //               relatedClaims,
  //               relatedProducts,
  //               relatedProjects,
  //               documentLink,
  //               substantiation_link: item.substantiation_link || '',
  //               documentName,
  //               doc_id: item.related_reference || '',
  //             };
  //           });

  //           // this.dataSource = new MatTableDataSource(tableData);
  //           // setTimeout(() => {
  //           //   this.dataSource.paginator = this.paginator;
  //           //   if (this.paginator) {
  //           //     this.paginator.firstPage();
  //           //   }
  //           //   this.cdr.detectChanges();
  //           // });

  //           // Show first 10 records immediately
  //           this.dataSource = new MatTableDataSource(tableData.slice(0, 10));
  //           setTimeout(() => {
  //             this.dataSource.paginator = this.paginator;
  //             if (this.paginator) {
  //               this.paginator.firstPage();
  //             }
  //             this.cdr.detectChanges();
  //           });

  //           // Progressive loading for the rest
  //           let currentIndex = 10;
  //           const chunkSize = 500; // You can adjust this for performance

  //           const loadNextChunk = () => {
  //             if (currentIndex >= tableData.length) return;
  //             const nextChunk = tableData.slice(
  //               currentIndex,
  //               currentIndex + chunkSize
  //             );
  //             // Add next chunk to dataSource
  //             this.dataSource.data = [...this.dataSource.data, ...nextChunk];
  //             currentIndex += chunkSize;
  //             // Schedule next chunk
  //             setTimeout(loadNextChunk, 0); // 0ms lets UI update between chunks
  //           };

  //           loadNextChunk();

  //           this.noDataMessage = '';
  //           // Set up filterPredicate
  //           // new code
  //           // In ngOnInit or after setting up dataSource:
  //           this.dataSource.filterPredicate = (data, filter: string) => {
  //             let search = {};
  //             try {
  //               search = JSON.parse(filter);
  //             } catch {}

  //             const includes = (field: any, value: any) =>
  //               String(field || '')
  //                 .toLowerCase()
  //                 .includes(String(value || '').toLowerCase());

  //             const relatedProductsStr = Array.isArray(data.relatedProducts)
  //               ? data.relatedProducts.join(', ')
  //               : String(data.relatedProducts || '');
  //             const relatedProjectsStr = Array.isArray(data.relatedProjects)
  //               ? data.relatedProjects.join(', ')
  //               : String(data.relatedProjects || '');
  //             const relatedClaimsStr = Array.isArray(data.relatedClaims)
  //               ? data.relatedClaims.join(', ')
  //               : String(data.relatedClaims || '');

  //             return (
  //               (!search['substantiationId'] ||
  //                 includes(
  //                   data.substantiationId,
  //                   search['substantiationId']
  //                 )) &&
  //               (!search['description'] ||
  //                 includes(data.description, search['description'])) &&
  //               (!search['relatedProducts'] ||
  //                 includes(relatedProductsStr, search['relatedProducts'])) &&
  //               (!search['relatedProjects'] ||
  //                 includes(relatedProjectsStr, search['relatedProjects'])) &&
  //               (!search['relatedClaims'] ||
  //                 includes(relatedClaimsStr, search['relatedClaims']))
  //             );
  //           };

  //           const updateFilter = () => {
  //             this.dataSource.filter = JSON.stringify({
  //               substantiationId: this.substantiationIdFilter.value,
  //               description: this.descriptionFilter.value,
  //               relatedProducts: this.relatedProductsFilterCtrl.value,
  //               relatedProjects: this.relatedProjectsFilterCtrl.value,
  //               relatedClaims: this.relatedClaimsFilterCtrl.value,
  //             });
  //           };

  //           this.substantiationIdFilter.valueChanges.subscribe(updateFilter);
  //           this.descriptionFilter.valueChanges.subscribe(updateFilter);
  //           this.relatedProductsFilterCtrl.valueChanges.subscribe(updateFilter);
  //           this.relatedProjectsFilterCtrl.valueChanges.subscribe(updateFilter);
  //           this.relatedClaimsFilterCtrl.valueChanges.subscribe(updateFilter);

  //           // Initial filter (optional)
  //           updateFilter();
  //         } else if (response.message) {
  //           this.dataSource = new MatTableDataSource([]);
  //           this.noDataMessage = response.message;
  //         } else {
  //           this.dataSource = new MatTableDataSource([]);
  //           this.noDataMessage = 'No results found.';
  //         }
  //         this.loadingService.setLoading(false);
  //       },
  //       error: (error) => {
  //         // this.dataSource = new MatTableDataSource([]);
  //         // //this.noDataMessage = error?.message || 'No results found.';
  //         // this.noDataMessage = 'No results found.';
  //         // this.loadingService.setLoading(false);
  //         clearTimeout(timeoutId);
  //         this.loadingService.setLoading(false);

  //         // If error is a timeout error, show a specific popup
  //         if (
  //           error &&
  //           error.message &&
  //           error.message.toLowerCase().includes('timeout')
  //         ) {
  //           const dialogConfig = new MatDialogConfig();
  //           dialogConfig.disableClose = true;
  //           dialogConfig.height = '190px';
  //           dialogConfig.width = '390px';
  //           dialogConfig.data = {
  //             message:
  //               'Search is taking too much time. Try searching with a different keyword.',
  //             buttons: [{ id: 'OK', text: 'OK' }],
  //             submitButtonId: 'OK',
  //             messageType: 'fileUpload',
  //             type: PopupType.ERROR,
  //           } as any;
  //           this.dialog.open(IraAlertPopupComponent, dialogConfig);
  //         } else {
  //           this.dataSource = new MatTableDataSource([]);
  //           this.noDataMessage = 'No results found.';
  //         }
  //       },
  //     });
  // }

  pendingSearchResponse: any = null; // Add this property to your class

  onSearchClick() {
    this.lastSearchType = this.selectedSearchType;
    this.noDataMessage = ''; // Reset message before each search

    const data = {
      session_id: sessionStorage.getItem('sessionId'),
      product_name:
        this.selectedSearchType === 'Product' ? this.searchText : '',
      project_name:
        this.selectedSearchType === 'Project' ? this.searchText : '',
      claim_la_statement:
        this.selectedSearchType === 'Claim/LA' ? this.searchText : '',
      document_name:
        this.selectedSearchType === 'Document Name' ? this.searchText : '',
      document_content:
        this.selectedSearchType === 'Document Content' ? this.searchText : '',
      environment: localStorage.getItem('environment'),
      geography_id: localStorage.getItem('geography') || '',
      created_by: this.createdByMeChecked ? localStorage.getItem('userId') : '',
    };

    this.loadingService.setLoading(true);

    //const SEARCH_TIMEOUT = 7000; // 7 seconds
    const SEARCH_TIMEOUT = 13000; // 13 seconds
    let timeoutTriggered = false;
    let searchSubscription: any;

    const timeoutId = setTimeout(() => {
      timeoutTriggered = true;
      this.loadingService.setLoading(false);

      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.height = '190px';
      dialogConfig.width = '390px';
      dialogConfig.data = {
        message:
          'The search is taking longer than expected. Would you like to wait or start a new search instead?',
        buttons: [
          { id: 'CANCEL', text: 'Cancel' },
          { id: 'CONTINUE', text: 'Continue' },
        ],
        submitButtonId: 'CONTINUE',
        messageType: 'longWait',
        type: 'PROCEED',
      } as any;

      this.dialog
        .open(IraAlertPopupComponent, dialogConfig)
        .afterClosed()
        .subscribe((result) => {
          console.log(result, 'dialog result');
          if (result === false) {
            this.loadingService.setLoading(true);
            timeoutTriggered = false;
            // If we have a pending response, assign it now
            if (this.pendingSearchResponse) {
              this.assignSearchResponseToUI(this.pendingSearchResponse);
              this.pendingSearchResponse = null;
              this.loadingService.setLoading(false);
            }
          }
          if (result === true) {
            if (searchSubscription) {
              searchSubscription.unsubscribe();
            }
          }
        });
    }, SEARCH_TIMEOUT);

    searchSubscription = this.substantiationPopupService
      .getSearchSubstantiation(data)
      .subscribe({
        next: (response) => {
          console.log(response, 'response aaa');
          clearTimeout(timeoutId);

          if (timeoutTriggered) {
            // Store the response for later if popup is open
            this.pendingSearchResponse = response;
            this.loadingService.setLoading(false);
            return;
          }

          // Normal UI update if no timeout
          this.assignSearchResponseToUI(response);
          this.loadingService.setLoading(false);
        },
        error: (error) => {
          clearTimeout(timeoutId);
          this.loadingService.setLoading(false);

          if (
            error &&
            error.message &&
            error.message.toLowerCase().includes('timeout')
          ) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.height = '190px';
            dialogConfig.width = '390px';
            dialogConfig.data = {
              message:
                'The search is taking longer than expected. Please try using a different keyword.',
              buttons: [{ id: 'OK', text: 'OK' }],
              submitButtonId: 'OK',
              messageType: 'fileUpload',
              type: PopupType.ERROR,
            } as any;
            this.dialog.open(IraAlertPopupComponent, dialogConfig);
          } else {
            this.dataSource = new MatTableDataSource([]);
            this.noDataMessage = 'No results found.';
          }
        },
      });
  }

  // Helper function to assign response to UI
  assignSearchResponseToUI(response: any) {
    if (response && Array.isArray(response) && response.length > 0) {
      const tableData = response.map((item) => {
        const substantiationId = item['substantiation'] || '';
        const description = item['description'] || '';
        let relatedClaims: string[] = [];
        if (Array.isArray(item.related_claims) && item.related_claims.length) {
          relatedClaims = item.related_claims.map((claim) =>
            `${claim.claim_name || ''} - ${claim.claim_statement || ''}`.trim()
          );
        } else if (Array.isArray(item.related_la) && item.related_la.length) {
          relatedClaims = item.related_la.map((la) =>
            `${la.la_name || ''} - ${la.la_statement || ''}`.trim()
          );
        }
        let relatedProjects: string[] = [];
        if (this.selectedSearchType === 'Project') {
          if (Array.isArray(item.related_projects)) {
            relatedProjects = item.related_projects.map(
              (proj) => proj['project__vr.name__v'] || ''
            );
          }
        } else {
          relatedProjects = Array.isArray(item.related_projects)
            ? item.related_projects
            : [];
        }
        const relatedProducts = Array.isArray(item.related_products)
          ? item.related_products
          : [];
        const documentLink =
          item.doc_link === null ||
          item.doc_link === undefined ||
          item.doc_link === 'null' ||
          item.doc_link === 'undefined'
            ? ''
            : item.doc_link;
        const documentName = item.doc_name;

        return {
          substantiationId,
          description,
          relatedClaims,
          relatedProducts,
          relatedProjects,
          documentLink,
          substantiation_link: item.substantiation_link || '',
          documentName,
          doc_id: item.related_reference || '',
        };
      });

      this.dataSource = new MatTableDataSource(tableData.slice(0, 10));
      setTimeout(() => {
        this.dataSource.paginator = this.paginator;
        if (this.paginator) {
          this.paginator.firstPage();
        }
        this.cdr.detectChanges();
      });

      let currentIndex = 10;
      const chunkSize = 500;
      const loadNextChunk = () => {
        if (currentIndex >= tableData.length) return;
        const nextChunk = tableData.slice(
          currentIndex,
          currentIndex + chunkSize
        );
        this.dataSource.data = [...this.dataSource.data, ...nextChunk];
        currentIndex += chunkSize;
        setTimeout(loadNextChunk, 0);
      };
      loadNextChunk();

      this.noDataMessage = '';
      this.dataSource.filterPredicate = (data, filter: string) => {
        let search = {};
        try {
          search = JSON.parse(filter);
        } catch {}

        const includes = (field: any, value: any) =>
          String(field || '')
            .toLowerCase()
            .includes(String(value || '').toLowerCase());

        const relatedProductsStr = Array.isArray(data.relatedProducts)
          ? data.relatedProducts.join(', ')
          : String(data.relatedProducts || '');
        const relatedProjectsStr = Array.isArray(data.relatedProjects)
          ? data.relatedProjects.join(', ')
          : String(data.relatedProjects || '');
        const relatedClaimsStr = Array.isArray(data.relatedClaims)
          ? data.relatedClaims.join(', ')
          : String(data.relatedClaims || '');

        return (
          (!search['substantiationId'] ||
            includes(data.substantiationId, search['substantiationId'])) &&
          (!search['description'] ||
            includes(data.description, search['description'])) &&
          (!search['relatedProducts'] ||
            includes(relatedProductsStr, search['relatedProducts'])) &&
          (!search['relatedProjects'] ||
            includes(relatedProjectsStr, search['relatedProjects'])) &&
          (!search['relatedClaims'] ||
            includes(relatedClaimsStr, search['relatedClaims']))
        );
      };

      const updateFilter = () => {
        this.dataSource.filter = JSON.stringify({
          substantiationId: this.substantiationIdFilter.value,
          description: this.descriptionFilter.value,
          relatedProducts: this.relatedProductsFilterCtrl.value,
          relatedProjects: this.relatedProjectsFilterCtrl.value,
          relatedClaims: this.relatedClaimsFilterCtrl.value,
        });
      };

      this.substantiationIdFilter.valueChanges.subscribe(updateFilter);
      this.descriptionFilter.valueChanges.subscribe(updateFilter);
      this.relatedProductsFilterCtrl.valueChanges.subscribe(updateFilter);
      this.relatedProjectsFilterCtrl.valueChanges.subscribe(updateFilter);
      this.relatedClaimsFilterCtrl.valueChanges.subscribe(updateFilter);

      updateFilter();
    } else if (response.message) {
      this.dataSource = new MatTableDataSource([]);
      this.noDataMessage = response.message;
    } else {
      this.dataSource = new MatTableDataSource([]);
      this.noDataMessage = 'No results found.';
    }
  }

  @ViewChildren('relatedList') relatedListRefs!: QueryList<ElementRef>;
  //isOverflowing: boolean[] = [];

  // checkOverflow() {
  //   this.relatedListRefs.forEach((ref, idx) => {
  //     const el = ref.nativeElement;
  //     // For horizontal overflow (single-line)
  //     this.isOverflowing[idx] = el.scrollWidth > el.clientWidth;
  //     // For vertical overflow (multi-line), use:
  //     // this.isOverflowing[idx] = el.scrollHeight > el.clientHeight;
  //   });
  // }

  isOverflowing: { [id: string]: boolean } = {};

  checkOverflow(div: HTMLElement, id: string) {
    // For 2 lines: height > 2 * line-height
    const lineHeight = parseFloat(getComputedStyle(div).lineHeight);
    const maxHeight = lineHeight * 2;
    this.isOverflowing[id] = div.scrollHeight > maxHeight;
  }

  // pdf documnet opening
  // pdfOpen(){
  //   const data ={
  //     session_id: sessionStorage.getItem('sessionId'),
  //     doc_id: '7904_0_1',
  //     environment: localStorage.getItem('environment'),
  //   }
  //   this.substantiationPopupService.getDocFrontpage(data){

  //   }
  // }

  // onDocumentImageClick(element: any) {
  //   // Use element.document_link if you have a real URL, otherwise:
  //   this.dialog.open(DocumentViewerDialogComponent, {
  //     width: '270px',
  //     data: {
  //       url: 'https://www.aeee.in/wp-content/uploads/2020/08/Sample-pdf.pdf', // Sample PDF URL
  //       searchText: this.searchText,
  //       selectedSearchType: this.selectedSearchType,
  //     },
  //   });
  // }

  onDocumentImageClick(element: any) {
    console.log(element, 'Element data from popup');
    this.loadingService.setLoading(true);
    // Get doc_id from element, or use your fallback (e.g. element.doc_id or element.document_id)
    const doc_id = element.doc_id || ''; //'10212_0_1'
    const doc_link = element.documentLink;

    const data = {
      session_id: sessionStorage.getItem('sessionId'),
      doc_id: doc_id,
      environment: localStorage.getItem('environment'),
    };

    this.substantiationPopupService.getDocFrontpage(data).subscribe({
      next: (response) => {
        // const imageUrl = 'data:image/png;base64,' + response.image_base64;
        const pdfUrl = 'data:application/pdf;base64,' + response.pdf_base64;
        //const pdfUrl = 'https://www.orimi.com/pdf-test.pdf';

        console.log(pdfUrl);
        this.dialog.open(DocumentViewerDialogComponent, {
          width: '270px',
          data: {
            url: pdfUrl, // Sample PDF URL
            searchText: this.searchText,
            selectedSearchType: this.selectedSearchType,
            documentLink: doc_link,
          },
        });
        this.loadingService.setLoading(false);
      },
      error: (err) => {
        // Handle error here
        console.error('Failed to fetch document frontpage:', err);
        this.loadingService.setLoading(false);
      },
    });
  }

  isOverflowing1: { [id: string]: boolean } = {};

  checkOverflow1(element: HTMLElement, id: string) {
    // This checks if the content overflows its div
    this.isOverflowing[id] =
      element.scrollWidth > element.clientWidth ||
      element.scrollHeight > element.clientHeight;
  }

  // create tab logic
  onTabChanged(index: number) {
    // console.log(index, 'index');
    if (index === 2) {
      this.fetchDropdownOptions();
    }
    if (index === 0) {
      //this.fetchRecentlyUsedSubstantiation();
    }
  }

  // fetchDropdownOptions() {
  //   const payload = {
  //     session_id: sessionStorage.getItem('sessionId'),
  //     environment: localStorage.getItem('environment'),
  //   };
  //   this.loadingService.setLoading(true);
  //   this.substantiationPopupService.getDropdownOptions(payload).subscribe({
  //     next: (response) => {
  //       //console.log(response, 'response');
  //       this.subtype_options = (response.subtype_labels || []).map((label) => ({
  //         label,
  //         value: label,
  //       }));

  //       this.country_options = (response.country_labels || []).map((label) => ({
  //         label,
  //         value: label,
  //       }));

  //       this.filteredCountryOptions = this.country_options;

  //       // Match selectedGeography case-insensitively
  //       const matchedGeo = this.country_options.find(
  //         (opt) =>
  //           opt.value.toLowerCase() ===
  //           (this.selectedGeography || '').toLowerCase()
  //       );
  //       console.log(matchedGeo, 'matchedGeo');
  //       console.log(this.selectedGeography, 'this.selectedGeography');

  //       if (matchedGeo) {
  //         this.createDataForm.patchValue({
  //           geography: matchedGeo.value,
  //         });
  //       }

  //       this.loadingService.setLoading(false);
  //     },
  //     error: (error) => {
  //       //console.error('Failed to fetch dropdown options:', error);
  //       this.loadingService.setLoading(false);
  //     },
  //   });
  // }

  fetchDropdownOptions() {
    const payload = {
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
    };
    this.loadingService.setLoading(true);
    this.substantiationPopupService.getDropdownOptions(payload).subscribe({
      next: (response) => {
        this.subtype_options = (response.subtype_labels || []).map((label) => ({
          label,
          value: label,
        }));

        // Parse countryData from localStorage
        let countryData: any[] = [];
        try {
          const raw = localStorage.getItem('geographyDataValues');
          countryData = raw ? JSON.parse(raw) : [];
        } catch {
          countryData = [];
        }

        // API response options
        const apiOptions = (response.country_labels || []).map((label) => ({
          label,
          value: label,
        }));

        // Selected geography (case-insensitive match)
        const selectedGeo = (this.selectedGeography || '').trim();
        let selectedOption = null;
        if (selectedGeo) {
          selectedOption =
            apiOptions.find(
              (opt) => opt.value.toLowerCase() === selectedGeo.toLowerCase()
            ) ||
            countryData.find(
              (c) => c.country_name.toLowerCase() === selectedGeo.toLowerCase()
            );
        }

        // Country names from your data array (excluding selectedGeo)
        const countryDataOptions = countryData
          .filter(
            (c) =>
              !selectedGeo ||
              c.country_name.toLowerCase() !== selectedGeo.toLowerCase()
          )
          .map((c) => ({
            label: c.country_name,
            value: c.country_name,
          }));

        // Remove duplicates from apiOptions (exclude selectedGeo and countryDataOptions)
        const usedNames = new Set(
          [
            ...(selectedOption
              ? [selectedOption.label || selectedOption.country_name]
              : []),
            ...countryDataOptions.map((c) => c.label),
          ].map((n) => n.toLowerCase())
        );

        const filteredApiOptions = apiOptions.filter(
          (opt) => !usedNames.has(opt.label.toLowerCase())
        );

        // Build the final dropdown list
        this.filteredCountryOptions = [
          ...(selectedOption
            ? [
                {
                  label: selectedOption.label || selectedOption.country_name,
                  value: selectedOption.label || selectedOption.country_name,
                },
              ]
            : []),
          ...countryDataOptions,
          ...filteredApiOptions,
        ];

        // Patch the selected value if needed
        if (selectedOption) {
          this.createDataForm.patchValue({
            geography: selectedOption.label || selectedOption.country_name,
          });
        }

        this.loadingService.setLoading(false);
      },
      error: (error) => {
        this.loadingService.setLoading(false);
      },
    });
  }

  // to get recently used table data
  noDataMessagerecentlyUsed: any;
  fetchRecentlyUsedSubstantiation() {
    this.loadingService.setLoading(true); // Start loader
    const payload = {
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
      //user_id: 'suhana.s@unilever.com',
      user_id: localStorage.getItem('userId'),
    };

    this.substantiationPopupService
      .recentlyAddedSubstantiation(payload)
      .subscribe({
        next: (data) => {
          //  this.loadingService.setLoading(false);
          console.log('Recently used items:', data);
          if (data && data.message) {
            this.recent_dataSource = new MatTableDataSource([]);
            this.noDataMessagerecentlyUsed = data.message; // Show message in UI
            this.loadingService.setLoading(false);
            return;
          }
          const tableData = data.map((item) => {
            // Substantiation ID
            const substantiationId = item['substantiation'] || '';

            // Description (not present in response, default to empty)
            const description = item.reference_details?.description || '';

            // Related Claims/LA (not present in response, default to empty)
            const relatedClaims: string[] = [];

            // Related Projects (map from project_names)
            const relatedProjects: string[] = Array.isArray(item.project_names)
              ? item.project_names
              : [];

            // Related Products (map from product_titles)
            const relatedProducts: string[] = Array.isArray(item.product_titles)
              ? item.product_titles
              : [];

            // Document Name (from reference_details.reference_name)
            const documentName = item.reference_details?.reference_name || '';

            // Doc ID (from reference_details.reference_subtype)
            // const doc_id = item.reference_details?.reference_subtype || '';
            const subType = item.reference_details?.reference_subtype || '';
            const substantiation_link =
              item.reference_details?.substantiation_link || '';
            const documentLink = item.reference_details?.doc_link || '';

            return {
              substantiationId,
              description,
              relatedClaims,
              relatedProducts,
              relatedProjects,
              documentLink,
              substantiation_link,
              documentName,
              subType,
            };
          });
          //this.recent_dataSource = tableData;

          this.recent_dataSource = new MatTableDataSource(tableData);

          console.log(this.recent_dataSource, 'this.recent_dataSource');
          setTimeout(() => {
            this.recent_dataSource.paginator = this.paginator;
            if (this.paginator) {
              this.paginator.firstPage();
            }
            this.cdr.detectChanges();
          });
          this.loadingService.setLoading(false);
        },
        error: (err) => {
          console.error('Failed to load recently used items:', err);
        },
      });
  }
}
